import styled from '@emotion/styled'
import TabBackground from 'components/TabBackground'

const SectionBackground = styled(TabBackground)`
  margin: 1rem 0;
`

export default SectionBackground
